export enum MetersExportTemplate {
  MeterCounter = 'METER_COUNTER',
  MeterInvoicing = 'METER_INVOICING',
}
